import React from 'react';
import { useDispatch } from 'react-redux';
import DTQuestionOrInstructionView from '../../DTQuestionOrInstructionView';
import ButtonList from '../../Common/ButtonList/ButtonList';
import Question from '../../Common/Question/Question';
import { processRevolveOrderShipToCountry } from '../../../../../../actions/tools/DecisionTree/RevolveActions';

const DTRevolveOrderShipToCountryNode = () => {
  const dispatch = useDispatch();

  return (
    <DTQuestionOrInstructionView
      titleSection={<Question />}
      options={
        <ButtonList
          isButtonDisabled={false}
          selectionAction={(choice) => dispatch(processRevolveOrderShipToCountry(choice))}
        />
      }
      loading={false}
    />
  );
};

export default DTRevolveOrderShipToCountryNode;
